/* @ngInject */

export default ($window) => {
  return {
    link(scope, element, attrs) {
      // direction to use. Default to vertical scrolling
      let direction = attrs.stInfiniteScrollingDirection || 'vertical';

      // set the threshold. Default to 0 if not specified
      let threshold = parseInt(attrs.stInfiniteScrollingThreshold || 0, 10);

      // listen to the window if specified
      const useWindow = scope.$eval(attrs.stInfiniteScrollingWindow) || false;

      // set the enabled state. Default to true is not specified
      let enabled = attrs.stInfiniteScrollingEnabled
        ? scope.$eval(attrs.stInfiniteScrollingEnabled)
        : true;

      // target to bind our handler to
      const target = useWindow ? angular.element($window) : angular.element('#wrap');

      // function to check if the trigger point has been reached
      const canTrigger = useWindow
        ? function () {
            const doc = document.documentElement;

            if (direction === 'vertical') {
              return (
                enabled &&
                doc.offsetHeight -
                  $window.innerHeight -
                  ($window.pageYOffset - (doc.clientTop || 0)) <=
                  threshold
              );
            }
            return (
              enabled &&
              doc.offsetWidth -
                $window.innerWidth -
                ($window.pageXOffset - (doc.clientLeft || 0)) <=
                threshold
            );
          }
        : function () {
            const raw = element[0];

            if (direction === 'vertical') {
              return (
                enabled && raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - threshold
              );
            }
            return enabled && raw.scrollLeft + raw.offsetWidth >= raw.scrollWidth - threshold;
          };

      // our event handler
      const handler = function () {
        if (canTrigger()) {
          scope.$apply(attrs.stInfiniteScrolling);
        }
      };

      // add our handler to the targeted element
      target.on('scroll', handler);

      // allow threshold amount to be change dynamically
      attrs.$observe('stInfiniteScrollingThreshold', function (value) {
        threshold = parseInt(value || 0, 10);
      });

      // allow enabled state to be changed dynamically
      attrs.$observe('stInfiniteScrollingEnabled', function (value) {
        enabled = scope.$eval(value);
      });

      // allow enabled state to be changed dynamically
      attrs.$observe('stInfiniteScrollingDirection', function (value) {
        direction = value;
      });

      // remove the event handler when the scope is destroyed
      scope.$on('$destroy', function () {
        target.off('scroll', handler);
      });
    }
  };
};
